import { apiClient, signApiRequest } from ".";
import { useMutation } from "@tanstack/react-query";
import { CustomerCredentials } from "../ui/customerDataStore";
import { captureException } from "@sentry/react";

export const signOpenPolicy = async ({
  credentials,
  signText,
  nonce,
  returnPath,
}: {
  credentials: CustomerCredentials;
  signText: string;
  nonce?: string;
  returnPath?: string;
}) => {
  const signedRequest = await signApiRequest(
    "POST",
    `${import.meta.env.VITE_API_URL}/auth/sign`,
    credentials,
    { "content-type": "application/json" },
    {
      fid: credentials.identityId,
      signText,
      nonce,
      returnPath,
    },
  );

  const response = await apiClient(signedRequest);

  return response.data;
};

export const useSignOpenPolicy = () =>
  useMutation({
    onError: (error) => {
      captureException(error, {
        tags: {
          operation: "signOpenPolicy",
          errorType: error.name || "UnknownError",
        },
        extra: {
          apiEndpoint: "/auth/sign",
        },
        level: "error",
      });
    },
    mutationFn: ({
      credentials,
      signText,
      nonce,
      returnPath,
    }: {
      credentials: CustomerCredentials;
      signText: string;
      nonce?: string;
      returnPath?: string;
    }) =>
      signOpenPolicy({
        credentials,
        signText,
        nonce,
        returnPath,
      }),
  });
